<template>
  <Grow>
    <div v-if="isOpen">
      <Btn variant="bare" @click="isOpen = false">
        {{ $t('common.mark-as-read') }}
        <Icon id="close" :scale="0.4" />
      </Btn>
      <Icon id="check" />
      <p class="mrg0">
        {{ text }}
        <strong>{{ stations }}</strong>
      </p>
    </div>
  </Grow>
</template>

<script>
import eventBus from '@/eventBus';
import Grow from '@/components/transitions/Grow.vue';

/**
 * This component creates the "New station" popover that appears
 * next to the menu's item whenever a new station is activated.
 * @see https://jira.liip.ch/browse/TPFCOMM-2086
 */
export default {
  components: { Grow },
  data() {
    return {
      isOpen: false,
      stations: null,
      text: null,
    };
  },
  mounted() {
    eventBus.$on('toggleStationPopover', this.handleToggle);
  },
  beforeDestroy() {
    eventBus.$off('toggleStationPopover', this.handleToggle);
  },
  methods: {
    handleToggle(stations, action) {
      this.isOpen = true;
      switch (action) {
        case 'delete':
          this.text = this.$t(
            'courseConnection.disableStationDialog.delete-station-notification'
          );
          this.stations = stations;
          break;
        case 'create':
          this.text = this.$t(
            'courseConnection.disableStationDialog.new-station-notification'
          );
          this.stations = stations;
          break;
        default:
          this.text = this.$t(
            'courseConnection.disableStationDialog.stations-notification'
          );
          this.stations = stations.join(', ');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: absolute;
  width: max-content;
  max-width: 20em;
  color: $brand-700;
  right: 0;
  top: 50%;
  transform: translate(calc(100% + 2em), -50%);
  background-color: $brand-50;
  padding: 0.75em 1em;
  filter: drop-shadow(1px 0 0 $brand-500) drop-shadow(-1px 0 0 $brand-500)
    drop-shadow(0 1px 0 $brand-500) drop-shadow(0 -1px 0 $brand-500);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  row-gap: 0.5em;
  column-gap: 1em;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);
    background-color: $brand-50;
    width: 1em;
    height: 1em;
    clip-path: polygon(100% 0, 0 50%, 100% 100%);
  }

  > .btn {
    flex: 1 0 100%;
    text-align: right;
    font-size: small;
  }

  > .icon {
    flex: 0 0 auto;
  }

  > p {
    flex: 1;
  }
}
</style>
